<template>
    <div
        class="mx-auto overflow-hidden rounded-2xl bg-stack-background ring-4 ring-theme-border"
        :style="frameStyle"
    >
        <div ref="content" :style="contentStyle">
            <div class="flex items-center gap-3 px-4 pt-5">
                <div class="h-8 w-8 flex-none rounded-full bg-stack-line"></div>
                <div class="flex flex-1 flex-col gap-1.5">
                    <div class="h-2 w-2/5 rounded-full bg-stack-line"></div>
                    <div class="h-2 w-3/5 rounded-full bg-stack-line"></div>
                </div>
            </div>
            <div class="py-4">
                <slot></slot>
            </div>
            <div class="flex flex-col gap-1.5 px-4 pb-5">
                <div class="h-2 w-full rounded-full bg-stack-line"></div>
                <div class="h-2 w-4/5 rounded-full bg-stack-line"></div>
                <div class="h-2 w-1/2 rounded-full bg-stack-line"></div>
            </div>
        </div>
    </div>
</template>

<script>
// Muestra un bloque dentro de un teléfono simulado, con perfil y texto de
// relleno, renderizado al ancho de referencia de móvil y escalado con un
// factor común: así todos los estilos se comparan a la misma escala y se ve
// qué parte de la pantalla ocupa cada uno. El alto visible sigue al alto real
// del contenido (transform no afecta el layout), así que nada se recorta.
export const PHONE_PREVIEW_SCALE = 0.55;
const PHONE_REFERENCE_WIDTH = 375;

export default {
    name: "PhoneFramePreview",
    props: {
        scale: { type: Number, default: PHONE_PREVIEW_SCALE },
        referenceWidth: { type: Number, default: PHONE_REFERENCE_WIDTH }
    },
    data: () => ({
        contentHeight: 0
    }),
    computed: {
        frameStyle() {
            return {
                width: `${this.referenceWidth * this.scale}px`,
                height: this.contentHeight
                    ? `${this.contentHeight * this.scale}px`
                    : "auto"
            };
        },
        contentStyle() {
            return {
                width: `${this.referenceWidth}px`,
                transform: `scale(${this.scale})`,
                transformOrigin: "top left"
            };
        }
    },
    mounted() {
        this.updateContentHeight();
        if (typeof ResizeObserver === "undefined") return;
        this.resizeObserver = new ResizeObserver(this.updateContentHeight);
        this.resizeObserver.observe(this.$refs.content);
    },
    beforeDestroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
    },
    methods: {
        updateContentHeight() {
            const el = this.$refs.content;
            if (el) this.contentHeight = el.offsetHeight;
        }
    }
};
</script>
